import type { FaireProductEntity } from "../../entity_types/product";

export const p_gkqngpu9g4: FaireProductEntity = {
  token: "p_gkqngpu9g4",
  type: "product",
  name: "Women's Soft Cozy Plush Non-Slip Lounge Slippers",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/8b88ed74a83b4637c1d1e66ef52437a6f2b6c9e58180cc3164b602378a8cf7ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/775e7c8de7337ca165eb6d1b8a5fcf41225033e489a349767841a9a95e20d6c5.png",
    "https://cdn.faire.com/fastly/9282e1906b89ec83e25bb6613e4cf04559c9e27c3756dc7ff8217f78a96b914e.jpeg",
    "https://cdn.faire.com/fastly/9f6811a493c3730203f166ef226cd0456700849329b320e7568d7d8ccf9cb74a.jpeg",
    "https://cdn.faire.com/fastly/8796fac852ccad1201cce04391c00f0f0a30deba949d9a4b1abd7f30d875017b.png",
    "https://cdn.faire.com/fastly/628e5a305c3487ae6c436d01110cdcc9c9b8e69a8a997c98b4f246de9392238a.png",
    "https://cdn.faire.com/fastly/7a7221ab801aadce4197860fdf5b4f4ab392552fbf741cf448fbf65ddcda2ad9.jpeg"
  ],
  priceDollars: 25,
  description: "Crafted from our ultra-soft DreamPlush fabric, this slipper is the ultimate indulgence in comfort. With a velvety texture that’s irresistibly plush and decadently warm, it’s like a cozy hug for your feet. Designed for chilly mornings, relaxed evenings, and everything in between, these slippers bring our most luxurious fabric to your everyday unwind. The perfect add-on for cold-weather gifting, spa-inspired collections, or elevated loungewear assortments.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Cushioned interior for all-day softness\n• Easy slip-on style\n• Great for cold-weather gifting, spa bundles, and holiday assortments\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• Easy Care DreamPlush Fabric: 100% polyester, machine washable\n• Available in S (5–6), M (7–8), and L (9–10)",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:00.528Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
